export default __webpack_public_path__ + "static/media/coupon-icon.9a04359d.svg";